function chunk(arr, chunkSize) {
  if (chunkSize <= 0) {
    throw Error("chunkSize must be greater than 0");
  }
  const chunks = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    chunks.push(arr.slice(i, i + chunkSize));
  }
  return chunks;
}
function deduplicate(arr) {
  return arr.filter((item, i) => arr.indexOf(item) === i);
}
export {
  chunk,
  deduplicate
};
